<div class="warranty-tasks-list">
  @if (warranties.length) {
    @for (warranty of warranties; track warranty.id) {
      <div class="warranty-section mb-[40px]">
        @if (warranties.length > 1) {
          <div class="warranty-title text-type-3 mb-[20px]">{{ warranty.name }}</div>
        }

        @for (state of states; track state.key) {
          <div
            class="milestone-group mb-[24px]"
            [class.current-milestone]="state.key === currentStateKey(warranty)">
            <div class="milestone-header flex flex-row items-center justify-between mb-[8px]">
              <div class="flex flex-row items-center gap-[8px]">
                <span class="milestone-dot" [class.dot-current]="state.key === currentStateKey(warranty)"></span>
                <span class="text-type-13 uppercase">{{ state.label }}</span>
                @if (state.key === currentStateKey(warranty)) {
                  <span class="current-chip px-[10px] rounded-full">Current</span>
                }
                @if (openTaskCount(warranty, state.key)) {
                  <span class="open-count-chip px-[10px] rounded-full">
                    {{ openTaskCount(warranty, state.key) }} open
                  </span>
                }
              </div>
              @if (canManage()) {
                <button
                  mat-icon-button
                  aria-label="Milestone actions"
                  (click)="$event.stopPropagation()"
                  [matMenuTriggerFor]="milestoneMenu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #milestoneMenu="matMenu">
                  <button mat-menu-item (click)="addTask(warranty, state.key)">
                    <mat-icon>add</mat-icon>
                    <span>Add task</span>
                  </button>
                </mat-menu>
              }
            </div>

            @for (task of tasksFor(warranty, state.key); track task.id) {
              <div
                class="task-card mb-[8px] cursor-pointer"
                [class.task-closed]="task.status === 'closed'"
                [class.my-task]="isMyPendingTask(task)"
                [class.highlighted-row]="(task.uuid || task.id) === selectedTaskId"
                (click)="taskClicked(warranty, task)">
                <div class="task-row flex flex-row items-center justify-between">
                  <div class="flex flex-col gap-[2px]">
                    <div class="flex flex-row items-center gap-[8px]">
                      <span class="text-type-8">{{ task.title }}</span>
                      @if (isMyPendingTask(task)) {
                        <span class="my-task-chip px-[10px] rounded-full">Assigned to you</span>
                      }
                    </div>
                    <span class="text-type-14 text-[#60698B]">
                      {{ assigneeName(task) }}
                      @if (task.due_date) {
                        · due {{ task.due_date | date:'MMM d, y' }}
                      }
                    </span>
                  </div>
                  <div class="flex flex-row items-center gap-[4px]">
                    <span
                      class="status-chip px-[12px] rounded-full"
                      [class.chip-open]="task.status === 'open'"
                      [class.chip-closed]="task.status === 'closed'">
                      {{ task.status === 'closed' ? 'Closed' : 'Open' }}
                    </span>
                    @if (canManage() && task.status !== 'closed') {
                      <button
                        mat-icon-button
                        aria-label="Task actions"
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="taskMenu">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #taskMenu="matMenu">
                        <button mat-menu-item (click)="deleteTask(warranty, task)">
                          <mat-icon>delete</mat-icon>
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    }
                  </div>
                </div>
              </div>
            }

            @if (!tasksFor(warranty, state.key).length) {
              <div class="text-type-14 text-[#60698B] pl-[16px]">No tasks</div>
            }
          </div>
        }
      </div>
    }
  } @else if (loading) {
    <div class="no-data text-type-8 mt-[80px]">Loading tasks…</div>
  } @else {
    <div class="no-data text-type-8 mt-[80px]">No warranties configured for this project.</div>
  }
</div>
